/**
 * Filters the children list by a case-insensitive substring match on name, and optionally to
 * only children currently enabled for capture -- read from the live toggle state so a toggle
 * made this session is reflected immediately, not each child's originally-fetched flag.
 *
 * @param children - The full, unfiltered list of children for the site.
 * @param filters - The current search term and "only enabled" filter state.
 * @param toggleState - The current childId -> captureEnabled map, including any local toggles.
 * @returns The children matching both the search term and the "only enabled" filter.
 */
export const filterKinderConnectCaptureSettingsChildren = (children, { searchTerm, onlyEnabled }, toggleState) => {
    const trimmedSearchTerm = searchTerm.trim().toLowerCase();
    return children.filter(child => {
        if (trimmedSearchTerm.length > 0 && !child.name.toLowerCase().includes(trimmedSearchTerm)) {
            return false;
        }
        if (onlyEnabled && !toggleState[child.id]) {
            return false;
        }
        return true;
    });
};
